import { CapitolMark } from '@/icons/capitol-mark';
import type { AgentChatActivityEvent } from '@/services/agents/chat-stream';

export function humanizeToolName(name: string): string {
  return name.replace(/_/g, ' ');
}

export function progressLabel(events: AgentChatActivityEvent[]): string {
  for (let i = events.length - 1; i >= 0; i--) {
    const e = events[i];
    if (e.type === 'tool_call') {
      return `Running ${humanizeToolName(e.toolName || 'tool')}…`;
    }
    if (e.type === 'tool_result') {
      return `Finished ${humanizeToolName(e.toolName || 'tool')}, thinking…`;
    }
    if (e.type === 'status' && e.text) {
      return e.text;
    }
  }
  return 'Thinking…';
}

export function formatElapsed(seconds: number): string {
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}m ${s.toString().padStart(2, '0')}s`;
}

const THINKING_TAIL_CHARS = 160;

export function thinkingTail(thinking: string): string {
  const collapsed = thinking.replace(/\s+/g, ' ').trim();
  if (collapsed.length <= THINKING_TAIL_CHARS) return collapsed;
  return '…' + collapsed.slice(-THINKING_TAIL_CHARS);
}

interface ThinkingRowProps {
  label: string;
  elapsedSeconds?: number;
}

export function ThinkingRow({ label, elapsedSeconds }: ThinkingRowProps) {
  return (
    <>
      <CapitolMark className='size-6 shrink-0 animate-pulse text-primary' />
      <span className='min-w-0 flex-1 truncate text-left text-base text-foreground'>
        {label}
      </span>
      {elapsedSeconds !== undefined && elapsedSeconds >= 3 && (
        <span className='shrink-0 text-xs tabular-nums text-muted-foreground'>
          {formatElapsed(elapsedSeconds)}
        </span>
      )}
    </>
  );
}
